export default () => {

  const s = {}
  const init = () => {
    s.selects = document.querySelectorAll('.ct-custom-select');
    if (s.selects.length == 0) {
      return;
    }
    console.log('buildSwitchCustomSelectPanel', s);

    s.selects.forEach((selectEle) => {
      buildSwitchAction(selectEle);
    })

  }

  const buildSwitchAction = (select) => {
    const targetRoot = select.closest('.ct-tab-panel__panel');
    const panelWrapper = targetRoot.querySelector('.ct-form__panels');

    select.changeAction = () => {
      console.log('changeAction');
      panelWrapper.classList.add('is-release');
      switchAction(select);
    }
  }
  const switchAction = (select) => {
    const selectValId = select.getId();
    const translatePageUrl = (() => {
      return `/${['contact', selectValId].filter(h => h).join('/')}/`;
    })();

    if (isEqualePathname(translatePageUrl)) {
      return;
    }

    location.href = translatePageUrl;
  }
  const isEqualePathname = (comparePathname) => {
    const currentPathname = location.pathname;
    const currentPathnameTxt = /^\/contact\/?$/.test(currentPathname)
      ? 'contact'
      : currentPathname.match(/^\/?([a-z]*\/?[a-z]*)\/?$/)[1];
    const comparePathnameTxt = comparePathname.slice(1, -1);
    return currentPathnameTxt == comparePathnameTxt;
  }

  init();
}
